import RateLists from './RateLists';

export default RateLists;
